import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";

// Project Imports
import { colors } from "../../Styles/GlobalStyles/Variables";
import { GreenButton, GreyFilledButton } from "../Button/CustomButton";
import Iconify from "../Dashboard/Iconify";


const theme = createTheme({
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: "Public Sans, sans-serif",
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        scrollPaper: {
          alignItems: "flex-start",
          fontFamily: "Public Sans, sans-serif",
        },
      },
    },
  },
});

const ConfirmDialog = ({
  confirmDialog,
  setConfirmDialog, 
}) => {
  return (
    <ThemeProvider theme={theme}>
      <Dialog
        open={confirmDialog.isOpen}
        PaperProps={{
          style: { padding: 10 },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: 600,
            fontSize: "16px",
            fontFamily: "Public Sans, sans-serif",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontSize: "20px",
          }}
        >
          {confirmDialog.header}
          <IconButton
            onClick={() =>
              setConfirmDialog({ ...confirmDialog, isOpen: false })
            }
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent sx={{ fontSize: "14px", color: colors.primaryGrey }}>
          <Typography variant="subtitle2">{confirmDialog.title}</Typography>
          <br />
          {confirmDialog.note ? (
            <div
              style={{
                backgroundColor: confirmDialog.backgroundColor, 
                borderLeft: `3px solid ${confirmDialog.borderSideColor}`, 
                padding: "12px",
              }}
            >
              <p style={{ color: confirmDialog.color, fontWeight: 600 }}>
                <Iconify icon="gridicons:notice" />
                Note
              </p>
              <br />
              <p style={{ color: confirmDialog.subColor }}>
                {confirmDialog.subTitle}
              </p>
            </div>
          ) : (
            ""
          )} 
        </DialogContent>
        <DialogActions>
          <GreyFilledButton
            color="secondary"
            sx={{ fontFamily: "Public Sans, sans-serif", padding: "10px 25px" }}
            onClick={() =>
              setConfirmDialog({ ...confirmDialog, isOpen: false })
            }
          >
            Cancel
          </GreyFilledButton>
          <GreenButton
            sx={{ fontFamily: "Public Sans, sans-serif", padding: "10px 25px" }}
            color="primary"
            onClick={confirmDialog.onConfirm}
          >
            {confirmDialog?.isLoading ? (
              <CircularProgress size={24} />
            ) : (
              "I confirm"
            )}
          </GreenButton>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
};

export default ConfirmDialog;
